import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Hospital, Sparkles, ShieldCheck, CalendarCheck } from "lucide-react";

const ITEMS = [
  ["Home", "/", HomeIcon, "mnav-home", true],
  ["Hospitals", "/search?type=hospital", Hospital, "mnav-hospitals", false],
  ["HealthAI", "/healthai", Sparkles, "mnav-healthai", false],
  ["Insurance", "/insurance", ShieldCheck, "mnav-insurance", false],
  ["Bookings", "/dashboard", CalendarCheck, "mnav-bookings", false],
];

export function MobileNav() {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 navy border-t border-white/10 grid grid-cols-5" data-testid="mobile-bottom-nav">
      {ITEMS.map(([label, to, Icon, id, end]) => (
        <NavLink key={to} to={to} end={end} data-testid={id} className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[13px] font-semibold ${isActive ? "text-sky-300" : "text-slate-400"}`}>
          <Icon size={22} /> {label}
        </NavLink>
      ))}
    </nav>
  );
}
